import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { BaseComponent } from './base/base.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';

import { ContentAnimateDirective } from '../../core/content-animate/content-animate.directive';

import { NgbDropdownModule, NgbCollapseModule } from '@ng-bootstrap/ng-bootstrap';

import { FeahterIconModule } from '../../core/feather-icon/feather-icon.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { SelectDropDownModule } from 'ngx-select-dropdown'
import { DirectivesModule } from './directives/directives.module';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MaintenanceNoticeComponent } from './maintenance-notice/maintenance-notice.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotifyService } from 'src/app/services/notifyService';
import { MatSelectModule } from '@angular/material/select';
import { MatSelectFilterModule } from 'mat-select-filter';
import { RegionService } from 'src/app/services/region.service';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};


@NgModule({
  declarations: [BaseComponent, NavbarComponent, SidebarComponent, FooterComponent, ContentAnimateDirective, ChangepasswordComponent, MaintenanceNoticeComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    NgbDropdownModule,
    NgbCollapseModule,
    SelectDropDownModule,
    PerfectScrollbarModule,
    FeahterIconModule,
    DirectivesModule,
    MatDialogModule,
    TranslateModule,
    ReactiveFormsModule,
    MatSelectModule, 
    MatSelectFilterModule,
  ],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    NotifyService,
    RegionService,
  ]
})
export class LayoutModule { }
